import React, { Component } from 'react';
import {connect} from 'react-redux';
import LifeCounterContainer from '../styled/LifeCounterContainer';
import lifes from '../assets/lifes';

export default 
@connect(state => {
  return {
    life: state.game.life,
  }
})
class LifeCounter extends Component {
  render() {
    return (
      <LifeCounterContainer image={lifes[this.props.life-1]}/>
    );
  }
}
